import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IChannelsVenuesResponse } from './types';

export const fetchChannels = async (): Promise<IChannelsVenuesResponse> => {
  const url = `${API_URL}/channels`;
  try {
    const res = await fetch(url, {
      method: 'GET',
      cache: 'reload',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    if (!res.ok) throw new Error(res.statusText);
    return await res.json();
  } catch (e) {
    throw new Error('Could not fetch channels', { cause: e });
  }
};
